module.exports = __webpack_public_path__ + "static/img/notice-icon-2.2b268be.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/notice-icon-2.png
// module id = HKpY
// module chunks = 1